// Link the anonymous HubSpot visitor session (hubspotutk cookie) to the
// Contact created server-side via the API integration (inc/hubspot-integration.php).
// Without this, HubSpot has no way to know a form submission and a tracked
// browsing session belong to the same person, so the Contact's timeline
// would be missing all page-view/session history from before the submit.
document.addEventListener("wpcf7mailsent", (event) => {
  const inputs = event.detail && event.detail.inputs;
  if (!Array.isArray(inputs)) {
    return;
  }

  const emailField = inputs.find((field) => field.name === "email");
  const email = emailField && emailField.value ? emailField.value.trim() : "";
  if (!email) {
    return;
  }

  window._hsq = window._hsq || [];
  window._hsq.push(["identify", { email }]);
});
